/**
 * Labstep
 *
 * @module components/EntityState/Action/UpdateColor
 * @desc Update the color of an EntityState
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { PopupContainer } from 'labstep-web/core/Popup';
import type React from 'react';
import { CirclePicker } from 'react-color';
import type { EntityStateActionUpdateColorProps } from './types';

export const EntityStateActionUpdateColor: React.FC<
  EntityStateActionUpdateColorProps
> = ({ entityState }) => {
  const canEdit = useHasAccess(
    entityState.entityName,
    entityState.id,
    Action.edit,
  );
  return (
    <EntityUpdateContainer
      entityName={entityState.entityName}
      id={entityState.id}
    >
      {({ update }) => (
        <PopupContainer
          disabled={!canEdit}
          on="click"
          position="bottom left"
          inverted={false}
          trigger={
            <div
              style={{
                width: '20px',
                height: '20px',
                backgroundColor: entityState.color,
              }}
            />
          }
          content={
            <CirclePicker
              onChangeComplete={(color) => {
                update({ color: color.hex });
              }}
            />
          }
        />
      )}
    </EntityUpdateContainer>
  );
};
